import { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

const translations = {
  no: {
    // Navbar
    services: 'Tjenester',
    portfolio: 'Portefølje',
    contact: 'Kontakt',
    
    // Hero
    heroHeadline: 'Lynraske nettsider. Rå resultater.',
    heroSubheadline: 'Fra første kodelinje til ferdig produkt – vi bygger, forbedrer og drifter nettsider for ambisiøse bedrifter.',
    ctaPrimary: 'Få gratis nettside-analyse',
    ctaSecondary: 'Kontakt oss',
    
    // Problem/Solution
    problemTitle: 'Utfordringer vi løser',
    problem1Title: 'Trenger ny nettside?',
    problem1Desc: 'Vi utvikler profesjonelle nettsider fra scratch, skreddersydd til din bedrift og dine mål.',
    problem2Title: 'Treg eller utdatert side?',
    problem2Desc: 'Vi optimaliserer ytelse, design og brukeropplevelse for å øke konverteringer.',
    problem3Title: 'Mangler teknisk kompetanse?',
    problem3Desc: 'Vi håndterer alt det tekniske – du fokuserer på det du kan best.',
    solutionText: 'NordensWebStudio er et fullservice webstudio. Vi bygger nye nettsider fra grunnen av, forbedrer eksisterende løsninger, og tilbyr sikker hosting og drift – alt fra design til produksjon.',
    
    // Services
    servicesTitle: 'Våre tjenester',
    service1Title: 'Ny nettside fra scratch',
    service1Desc: 'Skreddersydd utvikling av profesjonelle nettsider bygget med moderne teknologi – fra første kodelinje til lansering.',
    service2Title: 'Forbedring av eksisterende nettside',
    service2Desc: 'Vi oppgraderer design, funksjonalitet og brukeropplevelse på din nåværende nettside.',
    service3Title: 'Ytelse & SEO-optimalisering',
    service3Desc: 'Raskere lastetider, bedre søkemotorrangering og økt synlighet på nett.',
    service4Title: 'Drift & vedlikehold',
    service4Desc: 'Sikker hosting, løpende oppdateringer og teknisk support – vi tar oss av alt.',
    
    // Pricing
    pricingTitle: 'Priser',
    pricingSubtitle: 'Transparente priser uten skjulte kostnader. Velg pakken som passer din bedrift.',
    pricing1Title: 'Ny nettside fra scratch',
    pricing1Desc: 'Komplett nettside bygget fra bunnen av.',
    pricing2Title: 'Forbedring av nettside',
    pricing2Desc: 'Oppgradering av eksisterende løsning.',
    pricing3Title: 'Ytelse & SEO',
    pricing3Desc: 'Optimalisering for hastighet og synlighet.',
    pricing4Title: 'Drift & vedlikehold',
    pricing4Desc: 'Løpende hosting og support.',
    
    // Portfolio
    portfolioTitle: 'Nylige prosjekter',
    viewProject: 'Se prosjekt',
    
    // Contact
    contactTitle: 'La oss bygge noe sammen',
    contactSubtitle: 'Enten du trenger en helt ny nettside eller ønsker å forbedre den du allerede har, er du velkommen til å ta kontakt for en uforpliktende samtale.',
    nameLabel: 'Navn',
    namePlaceholder: 'Ditt navn',
    emailLabel: 'E-post',
    emailPlaceholder: 'din@epost.no',
    websiteLabel: 'Nettside URL (valgfritt)',
    websitePlaceholder: 'https://dinside.no',
    messageLabel: 'Melding',
    messagePlaceholder: 'Fortell oss om ditt prosjekt – ny nettside, forbedringer, eller annet...',
    submitButton: 'Send forespørsel',
    submitting: 'Sender...',
    
    // Footer
    footerTagline: 'Fra idé til ferdig nettside. Alt på ett sted.',
    copyright: '© 2026 NordensWebStudio. Alle rettigheter reservert.',
  },
  en: {
    // Navbar
    services: 'Services',
    portfolio: 'Portfolio',
    contact: 'Contact',
    
    // Hero
    heroHeadline: 'Dominating the Digital Frontier.',
    heroSubheadline: 'From the first line of code to the finished product – we build, improve, and host websites for ambitious businesses.',
    ctaPrimary: 'Get a Free Website Audit',
    ctaSecondary: 'Contact Us',
    
    // Problem/Solution
    problemTitle: 'Challenges We Solve',
    problem1Title: 'Need a new website?',
    problem1Desc: 'We develop professional websites from scratch, tailored to your business and goals.',
    problem2Title: 'Slow or outdated site?',
    problem2Desc: 'We optimize performance, design, and user experience to boost conversions.',
    problem3Title: 'Lack technical expertise?',
    problem3Desc: 'We handle all the technical work – you focus on what you do best.',
    solutionText: 'NordensWebStudio is a full-service web studio. We build new websites from the ground up, improve existing solutions, and provide secure hosting and maintenance – from design to production.',
    
    // Services
    servicesTitle: 'Our Services',
    service1Title: 'New website from scratch',
    service1Desc: 'Custom development of professional websites built with modern technology – from the first line of code to launch.',
    service2Title: 'Website improvement',
    service2Desc: 'We upgrade the design, functionality, and user experience of your current website.',
    service3Title: 'Performance & SEO optimization',
    service3Desc: 'Faster load times, better search engine rankings, and increased online visibility.',
    service4Title: 'Hosting & maintenance',
    service4Desc: 'Secure hosting, ongoing updates, and technical support – we take care of everything.',
    
    // Pricing
    pricingTitle: 'Pricing',
    pricingSubtitle: 'Transparent pricing with no hidden costs. Choose the package that fits your business.',
    pricing1Title: 'New website from scratch',
    pricing1Desc: 'Complete website built from the ground up.',
    pricing2Title: 'Website improvement',
    pricing2Desc: 'Upgrade of existing solution.',
    pricing3Title: 'Performance & SEO',
    pricing3Desc: 'Optimization for speed and visibility.',
    pricing4Title: 'Hosting & maintenance',
    pricing4Desc: 'Ongoing hosting and support.',
    
    // Portfolio
    portfolioTitle: 'Recent Projects',
    viewProject: 'View Project',
    
    // Contact
    contactTitle: 'Let\'s build something together',
    contactSubtitle: 'Whether you need a brand new website or want to improve your existing one – get in touch for a free consultation.',
    nameLabel: 'Name',
    namePlaceholder: 'Your name',
    emailLabel: 'Email',
    emailPlaceholder: 'your@email.com',
    websiteLabel: 'Website URL (optional)',
    websitePlaceholder: 'https://yoursite.com',
    messageLabel: 'Message',
    messagePlaceholder: 'Tell us about your project – new website, improvements, or something else...',
    submitButton: 'Send Request',
    submitting: 'Sending...',
    
    // Footer
    footerTagline: 'From idea to finished website. All in one place.',
    copyright: '© 2026 NordensWebStudio. All rights reserved.',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'no'; // Default to Norwegian
  });

  const toggleLanguage = () => {
    const newLang = language === 'no' ? 'en' : 'no';
    setLanguage(newLang);
    localStorage.setItem('language', newLang);
  };

  const t = (key) => translations[language][key] || key;

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
